import { environment } from 'src/environments/environment';

export class Preconnect {
    public static setPreconnectLink = () => {
        const script = document.createElement('script');
        script.src = environment.GCS_URL;
        document.head.appendChild(script);
    };
}
